"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logExposureBulk = exports.logExposure = exports.fetchTreatmentsBulk = exports.fetchTreatment = void 0;

var _laboratoryLib = require("laboratory-lib");

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _promise = require("hub-http/helpers/promise");

var _makeRequest = function _makeRequest(request) {
  var method = request.method.toLowerCase();
  var args = {};

  if (method === 'post') {
    args.data = request.body;
  }

  return _noAuthApiClient.default[request.method.toLowerCase()](request.url, args);
};

var _treatmentRequestArgs = {
  key: '',
  identifier: ''
};
var _exposureRequestArgs = {
  key: '',
  identifier: ''
};

var fetchTreatment = function fetchTreatment() {
  var requestArgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _treatmentRequestArgs;
  var key = typeof requestArgs === 'string' ? requestArgs : requestArgs.key;
  var request = (0, _laboratoryLib.createTreatmentRequest)(key, requestArgs.identifier);
  return _makeRequest(request).then(_laboratoryLib.normalizeTreatment);
};

exports.fetchTreatment = fetchTreatment;

var fetchTreatmentsBulk = function fetchTreatmentsBulk() {
  var requestsRaw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var requestsComposed = requestsRaw.map(function () {
    var requestArgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _treatmentRequestArgs;
    return (0, _laboratoryLib.createTreatmentRequest)(requestArgs.key, requestArgs.identifier);
  });
  var bulkRequest = (0, _laboratoryLib.createBulkTreatmentRequest)(requestsComposed);
  return _makeRequest(bulkRequest).then(function (treatments) {
    return treatments.map(_laboratoryLib.normalizeTreatment);
  });
};

exports.fetchTreatmentsBulk = fetchTreatmentsBulk;

var logExposure = function logExposure() {
  var requestArgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _exposureRequestArgs;
  var request = (0, _laboratoryLib.getExposureLogRequest)(requestArgs);

  if (!request) {
    return new _promise.Promise(function (resolve) {
      return resolve();
    });
  }

  return _makeRequest(request);
};

exports.logExposure = logExposure;

var logExposureBulk = function logExposureBulk() {
  var requestsRaw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var bulkRequest = (0, _laboratoryLib.getExposureLogRequest)(requestsRaw);

  if (!bulkRequest) {
    return new _promise.Promise(function (resolve) {
      return resolve();
    });
  }

  return _makeRequest(bulkRequest);
};

exports.logExposureBulk = logExposureBulk;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/laboratory-client/static-2.96/js/index.js
// module id = 188
// module chunks = 5 6